(function () {
  'use strict';

  function initSection(section) {
    if (!section || !section.hasAttribute('data-alter-ego-lifestyle-section')) return;

    const swiperElement = section.querySelector('[data-lifestyle-swiper]');
    const pagination = section.querySelector('[data-pagination]');
    const paginationBars = section.querySelectorAll('[data-pagination-index]');

    let swiperInstance = null;
    let currentIsMobile = window.innerWidth <= 767;
    let resizeTimeout;
    let firstVideoAutoplayStarted = false;

    function destroySwiper() {
      if (swiperInstance) {
        swiperInstance.destroy(true, true);
        swiperInstance = null;
      }
    }

    function initSwiper() {
      if (!swiperElement || typeof Swiper === 'undefined') {
        if (typeof Swiper === 'undefined') {
          setTimeout(initSwiper, 100);
        }
        return;
      }

      destroySwiper();

      const isMobile = window.innerWidth <= 767;
      const slidesPerView = isMobile ? 1 : 3;
      const spaceBetween = 8;
      const allowSlide = isMobile;

      swiperInstance = new Swiper(swiperElement, {
        slidesPerView: slidesPerView,
        spaceBetween: spaceBetween,
        loop: false,
        speed: 300,
        allowTouchMove: allowSlide,
        allowSlideNext: allowSlide,
        allowSlidePrev: allowSlide,
        on: {
          init: function () {
            updatePagination(this.activeIndex);
          },
          slideChange: function () {
            updatePagination(this.activeIndex);
            pauseVideosInInactiveSlides(this);
            if (window.innerWidth <= 767 && this.slides && this.slides[this.activeIndex]) {
              const activeSlide = this.slides[this.activeIndex];
              if (activeSlide.querySelector('.alter-ego-lifestyle__video')) {
                playVideoInSlide(activeSlide, true);
              }
            }
          },
          resize: function () {
            const newIsMobile = window.innerWidth <= 767;
            this.params.slidesPerView = newIsMobile ? 1 : 3;
            this.params.allowTouchMove = newIsMobile;
            this.params.allowSlideNext = newIsMobile;
            this.params.allowSlidePrev = newIsMobile;
            this.update();
            updatePagination(this.activeIndex);
          },
        },
      });
    }

    function updatePagination(activeIndex) {
      paginationBars.forEach(function (bar, index) {
        const isActive = index === activeIndex;
        bar.classList.toggle('alter-ego-lifestyle__pagination-bar--active', isActive);
        bar.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
    }

    paginationBars.forEach(function (bar, index) {
      bar.addEventListener('click', function () {
        if (swiperInstance) {
          swiperInstance.slideTo(index);
          updatePagination(index);
        }
      });
    });

    function pauseVideoInSlide(slideElement) {
      if (!slideElement) return;

      const videoElement = slideElement.querySelector('.alter-ego-lifestyle__video');
      if (!videoElement || videoElement.paused) return;

      const videoId = videoElement.id;
      const buttonId = videoId.replace('lifestyle-video-', '');

      const playButton = section.querySelector('[data-play-button="' + buttonId + '"]');
      const pauseButton = section.querySelector('[data-pause-button="' + buttonId + '"]');
      const muteButton = section.querySelector('[data-mute-button="' + buttonId + '"]');
      const overlay = section.querySelector('[data-overlay="' + buttonId + '"]');

      videoElement.pause();

      if (playButton) {
        playButton.classList.remove('hidden');
      }

      if (overlay) {
        overlay.classList.remove('hidden');
      }

      if (pauseButton) {
        pauseButton.classList.remove('active');
      }

      if (muteButton) {
        muteButton.classList.remove('active');
      }
    }

    function pauseVideosInInactiveSlides(swiper) {
      if (!swiper || !swiper.slides) return;

      const activeIndex = swiper.activeIndex;
      const slidesPerView = swiper.params.slidesPerView || 1;

      swiper.slides.forEach(function (slide, index) {
        const isInActiveView = index >= activeIndex && index < activeIndex + slidesPerView;

        if (!isInActiveView) {
          pauseVideoInSlide(slide);
        }
      });
    }

    function playVideoInSlide(slideEl, muteForAutoplay) {
      if (!slideEl) return;
      const videoElement = slideEl.querySelector('.alter-ego-lifestyle__video');
      if (!videoElement) return;

      const muteAndHide = section.getAttribute('data-mute-and-hide-control') === 'true';
      const buttonId = videoElement.id.replace('lifestyle-video-', '');
      const playButton = section.querySelector('[data-play-button="' + buttonId + '"]');
      const pauseButton = section.querySelector('[data-pause-button="' + buttonId + '"]');
      const muteButton = section.querySelector('[data-mute-button="' + buttonId + '"]');
      const overlay = section.querySelector('[data-overlay="' + buttonId + '"]');
      const thumbnail = section.querySelector('[data-thumbnail="' + buttonId + '"]');

      section.querySelectorAll('.alter-ego-lifestyle__video').forEach(function (video) {
        if (video.id !== videoElement.id && !video.paused) {
          const otherButtonId = video.id.replace('lifestyle-video-', '');
          const otherSlide = video.closest('.swiper-slide');
          if (otherSlide) pauseVideoInSlide(otherSlide);
        }
      });

      if (thumbnail) thumbnail.classList.add('hidden');
      if (playButton) {
        playButton.classList.add('hidden');
        playButton.classList.remove('alter-ego-lifestyle__play-button--centered');
      }
      if (pauseButton) pauseButton.classList.add('active');
      if (muteButton && !muteAndHide) {
        muteButton.classList.add('active');
        muteButton.classList.toggle('is-muted', videoElement.muted);
      }
      if (muteForAutoplay) videoElement.muted = true;
      if (overlay) overlay.classList.add('hidden');
      videoElement.style.display = 'block';
      videoElement.play().catch(function (err) {
        console.error('Error playing video:', err);
      });
    }

    function startDesktopAutoplay() {
      if (window.innerWidth <= 767 || !swiperInstance || !swiperInstance.slides.length) return;
      const firstSlide = swiperInstance.slides[0];
      if (firstSlide && firstSlide.querySelector('.alter-ego-lifestyle__video')) {
        playVideoInSlide(firstSlide, true);
      }
    }

    function stopAllVideos() {
      if (!swiperInstance || !swiperInstance.slides) return;
      swiperInstance.slides.forEach(function (slide) {
        pauseVideoInSlide(slide);
      });
    }

    function startFirstVideoWhenInView() {
      if (firstVideoAutoplayStarted) return;
      firstVideoAutoplayStarted = true;
      setTimeout(function () {
        if (window.innerWidth > 767) {
          startDesktopAutoplay();
        } else if (
          swiperInstance &&
          swiperInstance.slides[0] &&
          swiperInstance.slides[0].querySelector('.alter-ego-lifestyle__video')
        ) {
          playVideoInSlide(swiperInstance.slides[0], true);
        }
      }, 500);
    }

    function setupViewportAutoplay() {
      const observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting || firstVideoAutoplayStarted) return;
            startFirstVideoWhenInView();
            observer.disconnect();
          });
        },
        { rootMargin: '0px', threshold: 0.25 },
      );
      if (section) observer.observe(section);
    }

    function initVideoControls() {
      const muteAndHide = section.getAttribute('data-mute-and-hide-control') === 'true';
      const playButtons = section.querySelectorAll('[data-play-button]');
      const pauseButtons = section.querySelectorAll('[data-pause-button]');
      const videos = section.querySelectorAll('.alter-ego-lifestyle__video');

      videos.forEach(function (video) {
        const videoId = video.id;
        const buttonId = videoId.replace('lifestyle-video-', '');
        const overlay = section.querySelector('[data-overlay="' + buttonId + '"]');
        const thumbnail = section.querySelector('[data-thumbnail="' + buttonId + '"]');
        const playButton = section.querySelector('[data-play-button="' + buttonId + '"]');
        const pauseButton = section.querySelector('[data-pause-button="' + buttonId + '"]');

        video.loop = false;
        if (muteAndHide) {
          video.muted = true;
        }

        if (overlay) {
          video.addEventListener('play', function () {
            overlay.classList.add('hidden');
          });

          video.addEventListener('pause', function () {
            overlay.classList.remove('hidden');
          });
        }

        const muteButton = section.querySelector('[data-mute-button="' + buttonId + '"]');
        if (muteButton && !muteAndHide) {
          video.addEventListener('play', function () {
            muteButton.classList.add('active');
            muteButton.classList.toggle('is-muted', video.muted);
          });
          video.addEventListener('pause', function () {
            muteButton.classList.remove('active');
          });
        }

        video.addEventListener('ended', function () {
          video.style.display = 'none';

          if (thumbnail) {
            thumbnail.classList.remove('hidden');
          }

          if (playButton) {
            playButton.classList.remove('hidden');
            playButton.classList.add('alter-ego-lifestyle__play-button--centered');
          }

          if (overlay) {
            overlay.classList.remove('hidden');
          }

          if (pauseButton) {
            pauseButton.classList.remove('active');
          }

          if (muteButton) {
            muteButton.classList.remove('active');
          }

          video.currentTime = 0;

          if (
            window.innerWidth > 767 &&
            swiperInstance &&
            swiperInstance.slides &&
            swiperInstance.slides.length > 1
          ) {
            const slide = video.closest('.swiper-slide');
            if (slide) {
              const slides = Array.from(section.querySelectorAll('.swiper-slide'));
              const currentIndex = slides.indexOf(slide);
              const nextIndex = (currentIndex + 1) % slides.length;
              const nextSlide = slides[nextIndex];
              if (nextSlide && nextSlide.querySelector('.alter-ego-lifestyle__video')) {
                setTimeout(function () {
                  playVideoInSlide(nextSlide, true);
                }, 300);
              }
            }
          }
        });
      });

      playButtons.forEach(function (playButton) {
        playButton.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();

          const buttonId = playButton.getAttribute('data-play-button');
          const videoId = 'lifestyle-video-' + buttonId;
          const thumbnail = section.querySelector('[data-thumbnail="' + buttonId + '"]');
          const pauseButton = section.querySelector('[data-pause-button="' + buttonId + '"]');
          const overlay = section.querySelector('[data-overlay="' + buttonId + '"]');
          const videoElement = document.getElementById(videoId);

          if (!videoElement) return;

          const allVideos = section.querySelectorAll('.alter-ego-lifestyle__video');
          allVideos.forEach(function (video) {
            if (video.id !== videoId && !video.paused) {
              const otherButtonId = video.id.replace('lifestyle-video-', '');
              const otherPlayButton = section.querySelector('[data-play-button="' + otherButtonId + '"]');
              const otherPauseButton = section.querySelector('[data-pause-button="' + otherButtonId + '"]');
              const otherMuteButton = section.querySelector('[data-mute-button="' + otherButtonId + '"]');
              const otherOverlay = section.querySelector('[data-overlay="' + otherButtonId + '"]');

              video.pause();

              if (otherPlayButton) {
                otherPlayButton.classList.remove('hidden');
              }

              if (otherOverlay) {
                otherOverlay.classList.remove('hidden');
              }

              if (otherPauseButton) {
                otherPauseButton.classList.remove('active');
              }

              if (otherMuteButton) {
                otherMuteButton.classList.remove('active');
              }
            }
          });

          if (thumbnail) {
            thumbnail.classList.add('hidden');
          }
          playButton.classList.add('hidden');
          playButton.classList.remove('alter-ego-lifestyle__play-button--centered');

          if (pauseButton) {
            pauseButton.classList.add('active');
          }

          const muteButton = section.querySelector('[data-mute-button="' + buttonId + '"]');
          if (muteButton && !muteAndHide) {
            muteButton.classList.add('active');
            muteButton.classList.toggle('is-muted', videoElement.muted);
          }
          if (muteAndHide) {
            videoElement.muted = true;
          }

          if (overlay) {
            overlay.classList.add('hidden');
          }

          videoElement.style.display = 'block';
          videoElement.play().catch(function (err) {
            console.error('Error playing video:', err);
          });
        });
      });

      pauseButtons.forEach(function (pauseButton) {
        pauseButton.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();

          const buttonId = pauseButton.getAttribute('data-pause-button');
          const videoId = 'lifestyle-video-' + buttonId;
          const playButton = section.querySelector('[data-play-button="' + buttonId + '"]');
          const overlay = section.querySelector('[data-overlay="' + buttonId + '"]');
          const videoElement = document.getElementById(videoId);

          if (!videoElement) return;

          videoElement.pause();

          if (playButton) {
            playButton.classList.remove('hidden');
          }

          if (overlay) {
            overlay.classList.remove('hidden');
          }

          pauseButton.classList.remove('active');

          const muteButton = section.querySelector('[data-mute-button="' + buttonId + '"]');
          if (muteButton) {
            muteButton.classList.remove('active');
          }
        });
      });

      const muteButtons = section.querySelectorAll(
        '[data-mute-button]:not(.alter-ego-lifestyle__mute-button--hidden-by-setting)',
      );
      muteButtons.forEach(function (muteButton) {
        muteButton.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();

          const buttonId = muteButton.getAttribute('data-mute-button');
          const videoId = 'lifestyle-video-' + buttonId;
          const videoElement = document.getElementById(videoId);

          if (!videoElement) return;

          videoElement.muted = !videoElement.muted;
          muteButton.classList.toggle('is-muted', videoElement.muted);
          muteButton.setAttribute('aria-label', videoElement.muted ? 'Unmute video' : 'Mute video');
        });
      });

      section.querySelectorAll('.alter-ego-lifestyle__video-wrapper').forEach(function (wrapper) {
        wrapper.addEventListener('click', function (e) {
          if (window.innerWidth > 767) return;
          if (
            e.target.closest(
              '.alter-ego-lifestyle__play-button, .alter-ego-lifestyle__pause-button, .alter-ego-lifestyle__mute-button, .alter-ego-lifestyle__product-info',
            )
          )
            return;

          const videoElement = wrapper.querySelector('.alter-ego-lifestyle__video');
          if (!videoElement) return;

          const buttonId = videoElement.id.replace('lifestyle-video-', '');
          const playButton = section.querySelector('[data-play-button="' + buttonId + '"]');
          const pauseButton = section.querySelector('[data-pause-button="' + buttonId + '"]');
          const muteButton = section.querySelector('[data-mute-button="' + buttonId + '"]');
          const thumbnail = section.querySelector('[data-thumbnail="' + buttonId + '"]');
          const overlay = section.querySelector('[data-overlay="' + buttonId + '"]');

          if (videoElement.paused) {
            if (muteAndHide) {
              videoElement.muted = true;
            }
            const allVideos = section.querySelectorAll('.alter-ego-lifestyle__video');
            allVideos.forEach(function (video) {
              if (video.id !== videoElement.id && !video.paused) {
                const otherButtonId = video.id.replace('lifestyle-video-', '');
                const otherPlayButton = section.querySelector('[data-play-button="' + otherButtonId + '"]');
                const otherPauseButton = section.querySelector('[data-pause-button="' + otherButtonId + '"]');
                const otherOverlay = section.querySelector('[data-overlay="' + otherButtonId + '"]');
                const otherMuteButton = section.querySelector('[data-mute-button="' + otherButtonId + '"]');
                video.pause();
                if (otherPlayButton) otherPlayButton.classList.remove('hidden');
                if (otherOverlay) otherOverlay.classList.remove('hidden');
                if (otherPauseButton) otherPauseButton.classList.remove('active');
                if (otherMuteButton) otherMuteButton.classList.remove('active');
              }
            });
            if (thumbnail) thumbnail.classList.add('hidden');
            if (playButton) playButton.classList.add('hidden');
            if (pauseButton) pauseButton.classList.add('active');
            if (muteButton && !muteAndHide) {
              muteButton.classList.add('active');
              muteButton.classList.toggle('is-muted', videoElement.muted);
            }
            if (overlay) overlay.classList.add('hidden');
            videoElement.style.display = 'block';
            videoElement.play().catch(function (err) {
              console.error('Error playing video:', err);
            });
          } else {
            videoElement.pause();
            if (playButton) playButton.classList.remove('hidden');
            if (overlay) overlay.classList.remove('hidden');
            if (pauseButton) pauseButton.classList.remove('active');
            if (muteButton) muteButton.classList.remove('active');
          }
        });
      });
    }

    function handleResize() {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(function () {
        const newIsMobile = window.innerWidth <= 767;

        if (newIsMobile !== currentIsMobile) {
          currentIsMobile = newIsMobile;
          stopAllVideos();
          destroySwiper();
          initSwiper();
        } else if (swiperInstance) {
          swiperInstance.update();
        }
      }, 150);
    }

    initSwiper();
    initVideoControls();
    setupViewportAutoplay();
    window.addEventListener('resize', handleResize);
  }

  function initAll() {
    document.querySelectorAll('[data-alter-ego-lifestyle-section]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    const section = document.querySelector(
      '[data-alter-ego-lifestyle-section][data-section-id="' + e.detail.sectionId + '"]',
    );
    if (section) {
      initSection(section);
    }
  });
})();
